import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { useDropzone } from 'react-dropzone';
import { Dropdown } from 'primereact/dropdown';
import './products.css'
import { RadioButton } from "primereact/radiobutton";
import Loader from '../../loader/loader'

//icons
import Edit from '../../../assets/icons/edit.svg';
import Trash from '../../../assets/icons/trash.svg';
import WhiteTrash from '../../../assets/icons/white-trash.svg'
import Upload from '../../../assets/icons/upload.svg'
import { AttachFileCreate, AttachFileDelete, AttachFileUpdate, baseUrl, bearer, CreateProduct, DeleteProduct, GetProduct, SearchProductGroup, SearchProducts, UpdateProduct } from '../../../utils/api';
import { Button, InputGroup } from 'react-bootstrap';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import useToastNotification from '../../../hooks/useToastNotification';
import { Skeleton } from 'primereact/skeleton';


function Banner() {
    const [addFormValidated, setAddFormValidated] = useState(false);
    const [editFormValidated, setEditFormValidated] = useState(false);

    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const { showError, showSuccess } = useToastNotification();
    const [addVisible, setAddVisible] = useState(false);
    const [editVisible, setEditVisible] = useState(false);
    const deleteDialog = useRef(null);
    const [status, setStatus] = useState(true);
    const [catName, setCatName] = useState('');
    const [catNum, setCatNum] = useState('');
    const [category, setCategoty] = useState('');
    const [productName, setProductName] = useState('');
    const [productNum, setProductNum] = useState('');
    const [productDescription, setProductDescription] = useState('');
    const [newProducts, setNewProduct] = useState(false);
    const [favoritProducts, setFavoritProduct] = useState(false);
    const [uploadedFile, setUploadedFile] = useState([]);
    const [labels, setLabels] = useState([]); // To manage the label array
    const [newLabel, setNewLabel] = useState(""); // برای ذخیره لیبل جدید تایپ شده
    const [isAdding, setIsAdding] = useState(false); // برای مدیریت نمایش یا مخفی کردن ورودی لیبل جدید
    const [defaultImg, setDefaultImg] = useState('');
    const [catId, setCatId] = useState('');

    const [loading, setLoading] = useState(false);

    const [items, setItems] = useState([]);
    const initialSelectedItemProperties = {
        "productGroupId": '',
        "title": "",
        "description": "",
        "code": "",
        "isActive": true,
        "isNew": true,
        "isFavorit": true,
        "displayOrder": 0,
        "lables": [],
        "images": [],
    };
    const [selectedItem, setSelectedItem] = useState({ ...initialSelectedItemProperties });
    const updateSelectedItem = (key, value) => {
        setSelectedItem(old => {
            let clone = { ...old };
            clone[key] = value;
            return clone;
        })
    };


    const [productGroupItems, setProductGroupItems] = useState([]);
    const [isAddingLabel, setIsAddingLabel] = useState(false);
    const openLabelAdding = () => {
        setIsAddingLabel(true);
        setTimeout(() => {
            document.getElementById('labels-input').focus();
        }, 100);
    };
    const [addingLabelText, setAddingLabelText] = useState('');
    const addLabelNew = () => {
        if (!addingLabelText.trim()) {
            return;
        }
        setSelectedItem(old => {
            let clone = { ...old };
            clone.lables.push(addingLabelText);
            return clone;
        });
        setAddingLabelText('');
        setIsAddingLabel(false);
    };
    const cancleAddLabelNew = () => {
        setAddingLabelText('');
        setIsAddingLabel(false);
    };
    const addLabelKeyUp = (e) => {
        if (e.key === "Enter") {
            if (addingLabelText.length > 0) {
                addLabelNew();
            }
            else {
                cancleAddLabelNew();
            }
        }
        else if (e.key === "Escape") {
            cancleAddLabelNew();
        }
    };
    const deleteLabel = (value) => {
        let labels = [...selectedItem.lables];
        labels = labels.filter(item => item !== value);
        updateSelectedItem("lables", labels);
    };

    const [imagePreview, setImagePreview] = useState([]);
    const [uploadStatus, setUploadStatus] = useState(null);
    const loadProducts = async (page = pageIndex, size = pageSize, filters = {}) => {
        console.log(filters)
        try {
            let response = await SearchProducts({
                pageIndex: page,
                pageSize: size,
                ...filters, // اضافه کردن فیلترها
            });
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);
        } catch (error) { }
    };
    const loadProductGroups = async () => {
        try {
            let response = await SearchProductGroup({ pageSize: 1000, pageIndex: 0 });
            setProductGroupItems(response.data.data.items);
        } catch (error) { }
    };
    useEffect(() => {
        let data = [];
        setItems(data);
        loadProducts(pageIndex, pageSize, {
            productGroupId: catId || null,

        });
    }, [pageIndex, pageSize]);

    useEffect(() => {
        loadProductGroups()
    }, []);
    // تابع افزودن لیبل با زدن Enter
    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && newLabel.trim() !== "") {
            e.preventDefault(); // جلوگیری از رفتار پیش‌فرض فرم
            addLabel();
        }
    };

    // تابع افزودن لیبل جدید
    const addLabel = () => {
        // if (labels.length) { // محدودیت تعداد لیبل (4 لیبل)
        setLabels([...labels, newLabel.trim()]); // افزودن لیبل جدید
        setNewLabel(""); // خالی کردن ورودی بعد از افزودن
        setIsAdding(false); // مخفی کردن ورودی و نمایش دکمه "+"
        // }
    };

    // تابع حذف لیبل
    const removeLabel = (index) => {
        const newLabels = labels.filter((_, i) => i !== index);
        setLabels(newLabels);
    };

    const onStatusChange = async (rowData, value) => {
        await UpdateProduct({ ...rowData, isActive: value }).then(() => {
            const updatedItems = items.map(item =>
                item.id === rowData.id ? { ...item, isActive: value } : item
            );
            setItems(updatedItems);
            showSuccess("عملیات با موفقیت انجام شد");
        }).catch(error => showError(error));
    };

    const indexGetter = (_, row) => {
        return row.rowIndex + 1;
    };

    const statusSwitchTemplate = (rowData) => {
        return (
            <InputSwitch
                checked={rowData.isActive}
                onChange={(e) => onStatusChange(rowData, e.value)}
            />
        );
    };

    const actionTemplate = (rowData) => {
        return (
            <div className='d-flex justify-content-center gap-2' style={{ borderRight: '0.5px solid #D2D2D2' }}>
                <img
                    src={Edit}
                    alt="edit"
                    className="cursor-pointer mx-1"
                    onClick={() => openEditDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
                <img
                    src={Trash}
                    alt="delete"
                    className="cursor-pointer mx-1"
                    onClick={() => openDeleteDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
            </div>
        );
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const openAddDialog = () => {
        setLoading(false);
        setUploadStatus("");
        setAddVisible(true);
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول
        if (productGroupItems.length > 0) {
            setCategoty(productGroupItems[0].id);
        }
    };
    const closeAddDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setAddFormValidated(false);
        setUploadStatus("");
        setAddVisible(false);
        document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
        // reset properties to default
        setImagePreview([]);
        setUploadedFile([]);
        setProductName("");
        setProductNum("");
        setLabels([])
        setProductDescription("");
        setNewProduct(false);
        setFavoritProduct(false);
        setStatus(true);
    };

    const openEditDialog = (rowData) => {
        setUploadStatus("");
        setSelectedItem(rowData);
        setEditVisible(true);
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

    };
    const closeEditDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setEditFormValidated(false);
        setUploadStatus("");
        setEditVisible(false);
        document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

    };
    const deleteItem = async (item) => {
        await DeleteProduct({ id: item.id }).then(() => {
            showSuccess("عملیات با موفقیت انجام شد");
            setItems(old => old.filter(filter => item.id !== filter.id));
        }).catch(error => {
            showError(error.response.data.message);
        });
    };

    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {
                deleteItem(rowData)
                document.body.style.overflow = 'auto';
            },
            reject: () => {
                document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };



    // Upload handler for add
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (uploadedFile.length >= 4) {
                showError('حداکثر تعداد عکس ها 4 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 4 - uploadedFile.length); // Limit to the remaining count
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // Clear previews and set new previews
            const newPreviews = newFiles.map(file => URL.createObjectURL(file));
            let newPreviewsValue = [...imagePreview, ...newPreviews];
            setImagePreview(newPreviewsValue);
            setDefaultImg(newPreviewsValue.length - 1);

            // Automatically upload the file
            // newFiles.forEach(file => handleFileUpload(file));
        },

        accept: 'image/*',
        maxFiles: 4 // Limit to a maximum of 4 files

        // Automatically upload the file
    });



    const handleFileUploadAdd = async (file, id, isDefault) => {
        let base64 = await toBase64(file);
        base64 = base64.substr(base64.indexOf(',') + 1, base64.length);


        // const formData = new FormData();
        // formData.append('filsBase64', base64);
        // formData.append('sourceId', id);
        // formData.append('isDefault', isDefault);
        let formData = {
            sourceId: id,
            filsBase64: base64,
            isDefault
        };


        setUploadStatus('در حال آپلود فایل');
        await AttachFileCreate(formData)
            .then(data => {
                setUploadStatus('آپلود فایل با موفقیت انجام شد');
            })
            .catch(error => {
                setUploadStatus('عملیات آپلود با خطا مواجه شد');
            });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            try {
                setLoading(true);
                let payload = {
                    productGroupId: category,
                    title: productName,
                    description: productDescription,
                    code: productNum,
                    isActive: status,
                    isNew: newProducts,
                    isFavorit: favoritProducts,
                    displayOrder: 0,
                    lables: labels,
                };

                let res = await CreateProduct(payload)

                const id = res.data.data; //created item id
                await onAddItemSubmitted(id);
                setLoading(false);
                closeAddDialog();
                showSuccess("عملیات با موفقیت انجام شد");

            } catch (error) {
                setLoading(false);
                showError(error.response?.data?.message);
            }
        }
        else {
            setAddFormValidated(true);
        }

    };
    const onAddItemSubmitted = async (id) => {
        // add images if exist 
        for (let index = 0; index < uploadedFile.length; index++) {
            const image = uploadedFile[index];
            await handleFileUploadAdd(image, id, index === defaultImg);
        }

        // add new item to the top of the list
        await GetProduct({ id }).then(response => {
            setItems(old => [response.data.data, ...old]);
        }).catch(error => showError(error.response.data));
    }



    // Upload handler for edit
    const { getRootProps: getRootPropsEdit, getInputProps: getInputPropsEdit } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (selectedItem.images.length >= 4) {
                showError('حداکثر تعداد عکس ها 4 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 4 - uploadedFile.length); // Limit to the remaining count

            // Automatically upload the file
            newFiles.forEach(file => handleFileUpload(file));
        },

        accept: 'image/*',
        maxFiles: 4 // Limit to a maximum of 4 files
    });

    // Function to handle the file upload
    const handleFileUpload = async (file) => {
        let base64 = await toBase64(file);
        base64 = base64.substr(base64.indexOf(',') + 1, base64.length);


        // const formData = new FormData();
        // formData.append('filsBase64', base64);
        // formData.append('sourceId', selectedItem.id);
        // formData.append('isDefault', true);

        let formData = {
            sourceId: selectedItem.id,
            filsBase64: base64,
            isDefault: true,
        };


        setUploadStatus('در حال آپلود فایل');
        await AttachFileCreate(formData)
            .then(data => {
                updateImagesList(selectedItem.id);
                setUploadStatus('آپلود فایل با موفقیت انجام شد');
            })
            .catch(error => {
                setUploadStatus('عملیات آپلود با خطا مواجه شد');
            });
    };
    const handleRemoveImage = (index) => {
        setUploadedFile(prevFiles => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1); // Remove the file at the specified index
            return newFiles;
        });

        setImagePreview(prevPreviews => {
            const newPreviews = [...prevPreviews];
            newPreviews.splice(index, 1); // Remove the preview at the same index
            return newPreviews;
        });
    };

    const updateImagesList = async (id) => {
        await GetProduct({ id }).then(response => {
            const images = (response.data.data.images);
            setSelectedItem(old => ({ ...old, images }));
        });
    };
    const removeImage = async (index, image) => {

        await AttachFileDelete({ id: image.id })
            .then(() => {
                setSelectedItem((old) => {
                    // Clone the old object
                    const clone = { ...old };

                    // Filter out the image to be removed from the images array
                    clone.images = clone.images.filter((item) => item.id !== image.id);

                    // Update the isDefault property for the first image if necessary
                    clone.images = clone.images.map((item, index) => {
                        if (index === 0 && image.isDefault === true) {
                            return { ...item, isDefault: true };
                        }
                        return item;
                    });

                    return clone;
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const changeDefaultImage = async (id) => {
        console.log(id)
        await AttachFileUpdate({ imageId: id }).then(() => {
            setSelectedItem(old => {
                const clone = { ...old };
                clone.images = clone.images.map(item => {
                    if (item.id === id) {
                        return { ...item, isDefault: true };
                    }
                    else {
                        return { ...item, isDefault: false };
                    }
                })
                return clone;
            })

        }).catch((error) => {
            console.log(error);
        });
    };

    const submitEdit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            setLoading(true);
            try {
                let response = await UpdateProduct(selectedItem);
                if (response.status === 200) {
                    setItems(old => {
                        let clone = [...old];
                        clone = clone.map(item => {
                            if (item.id === selectedItem.id) {
                                item = selectedItem;
                            }
                            return item;
                        })
                        return clone;
                    })
                    showSuccess("عملیات با موفقیت انجام شد");
                    loadProducts()
                    closeEditDialog();
                }
            } catch (error) {
                showError(error.response.data.message);
            }
            finally {
                setLoading(false);
            }
        }
        else {
            setEditFormValidated(true);
        }
    };

    // قالب اسکلتون
    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };
    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);
        loadProducts(event.page, event.rows, {
            productGroupId: catId || null,

        });
    };

    const handleFilterChange = (catId) => {


        loadProducts(pageIndex, pageSize, {
            productGroupId: catId || null,

        });
    };
    return (
        <>
            <div>
                <Form.Group className="mb-3 col-md-2 col-lg-2 col-sm-12">
                    <Form.Label>گروه محصولات</Form.Label>
                    <Form.Select type="text" value={catId} onChange={(e) => {
                        const newCatId = e.target.value;
                        setCatId(newCatId);
                        handleFilterChange(newCatId);
                    }}>
                        <option value="">همه</option> {/* گزینه همه */}
                        {productGroupItems?.map(item =>
                            <option value={item.id}>{item.title}</option>
                        )}
                    </Form.Select>

                </Form.Group>
            </div>
            <div className='w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border'>
                <h6 className='font-bold text-sm mb-0'>محصولات</h6>
                <button className='btn btn-primary' onClick={openAddDialog}>تعریف محصول</button>
            </div>
            <div className=''>
                <DataTable value={items}
                    size="small"
                    paginator
                    rows={pageSize}
                    totalRecords={totalRecords}
                    lazy
                    onPage={handlePagination}
                    first={(pageIndex - 1) * pageSize} // Current first record index
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    tableStyle={{ minWidth: '50rem' }}>
                    <Column header="ردیف" body={indexGetter}></Column>
                    <Column field="title" header="نام محصول" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="code" header="شماره محصول" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="productGroupTitle" header="نام گروه محصول" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column header="وضعیت" body={statusSwitchTemplate}></Column>
                    <Column header="عملیات" body={actionTemplate} ></Column>
                </DataTable>
            </div>

            {/* add category  */}
            <Dialog header="تعریف محصول" visible={addVisible} maximizable style={{ width: '40vw' }} onHide={() => { if (!addVisible) return; closeAddDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={addFormValidated} className='mt-3' action='#' onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId='category'>
                            <Form.Label>گروه محصول مرتبط</Form.Label>
                            <Form.Select required type="text" placeholder="" value={category} onChange={(e) => setCategoty(e.target.value)} defaultValue={productGroupItems[0]?.id}>
                                {productGroupItems.map(item =>
                                    <option value={item.id}>{item.title}</option>
                                )}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                گروه محصول مرتبط را وارد کنید
                            </Form.Control.Feedback>

                        </Form.Group>
                        <Form.Group className="mb-3" controlId='name'>
                            <Form.Label>نام محصول</Form.Label>
                            <Form.Control type="text" required value={productName} onChange={(e) => setProductName(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                نام محصول را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId='number'>
                            <Form.Label>شماره محصول</Form.Label>
                            <Form.Control type="number" required value={productNum} onChange={(e) => setProductNum(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                شماره محصول را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>توضیحات محصول</Form.Label>
                            <Form.Control as="textarea" rows={3} type="text" value={productDescription} onChange={(e) => setProductDescription(e.target.value)} />
                        </Form.Group>


                        <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                            <Form.Check
                                label="محصول جدید"
                                checked={newProducts}
                                onChange={(e) => setNewProduct(e.target.checked)}
                            />
                            <Form.Check
                                dir='ltr'
                                label="محصول محبوب"
                                checked={favoritProducts}
                                onChange={(e) => setFavoritProduct(e.target.checked)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                            <InputSwitch checked={status} onChange={(e) => setStatus(e.value)} />
                            <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                        </Form.Group>
                        <div className="upload-box mt-4 mb-0 flex-1" {...getRootProps()} style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                            <input {...getInputProps()} />
                            <div>
                                <div>
                                    <img src={Upload} alt="" className='mx-auto' />

                                    <p className='text-xs mt-2 font-medium'>امکان آپلود چهارتصویر برای محصول وجود دارد.</p>
                                    <h6 className='text-[10px]'>بهترین ابعاد: 250 * 250</h6>
                                    <h6 className='text-[10px]'>ماکزیمم حجم تصویر: ...</h6>
                                </div>


                            </div>
                        </div>
                        <div className='d-flex gap-2 align-items-center' style={{ flexWrap: 'wrap' }}>
                            {
                                imagePreview.length > 0 &&
                                <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                    {imagePreview.map((image, index) => (
                                        <div className='list-defult'>

                                            <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                                <div className='upload-file-btn'>
                                                    <img src={image} alt="Uploaded preview" className="image-preview" />
                                                    <div className='upload-file-btn-bottom'>
                                                        <div className='d-flex align-items-center' >
                                                            <RadioButton inputId={image} name="selected-images" value={index} onChange={(e) => setDefaultImg(e.value)} checked={defaultImg === index} />
                                                            <label htmlFor="ingredient1" className="ml-2">پیش فرض</label>

                                                        </div>
                                                        <div>
                                                            <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>

                            }


                        </div>



                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}

                        <Form.Group className="mb-3 label-list mt-3" controlId="productLabels">
                            <Form.Label>لیبل محصول <span style={{ fontSize: '12px' }}>(برای ثبت لیبل دکمه enter را بزنید.)</span></Form.Label>
                            <div className="label-input-container">
                                {labels.map((label, index) => (
                                    <div key={index} className="label-item">
                                        <span className="label-text">{label}</span>
                                        <button className="remove-btn" onClick={() => removeLabel(index)}>
                                            <img src={WhiteTrash} alt="" />
                                        </button>
                                    </div>
                                ))}

                                {/* اگر ورودی باز است، ورودی متنی را نشان دهد */}
                                {isAdding ? (
                                    <input
                                        type="text"
                                        className="add-label-input"
                                        value={newLabel}
                                        onChange={(e) => setNewLabel(e.target.value)}
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        autoFocus
                                        onBlur={() => setIsAdding(false)} // اگر کاربر از ورودی خارج شد
                                    />
                                ) : (
                                    <button className="add-btn" onClick={() => setIsAdding(true)}>
                                        +
                                    </button>
                                )}
                            </div>
                        </Form.Group>


                        <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>
                    </Form>
                </div>
            </Dialog>



            {/* Edit popup  */}
            <Dialog header="ویرایش  محصول" visible={editVisible} maximizable style={{ width: '40vw' }} onHide={() => { if (!editVisible) return; closeEditDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form noValidate validated={editFormValidated} className='mt-3' onSubmit={submitEdit} onKeyUp={(e) => (e.key === "Enter") && e.preventDefault()}>
                        <Form.Group className="mb-3" >
                            <Form.Label>گروه محصول مرتبط</Form.Label>
                            <Form.Select type="text" required value={selectedItem.productGroupId} onChange={(e) => updateSelectedItem('productGroupId', e.target.value)}>
                                {productGroupItems.map(item =>
                                    <option value={item.id}>{item.title}</option>
                                )}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                گروه محصول را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>نام محصول</Form.Label>
                            <Form.Control type="text" required value={selectedItem.title} onChange={(e) => updateSelectedItem('title', e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                نام محصول را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>شماره محصول</Form.Label>
                            <Form.Control type="number" required value={selectedItem.code} onChange={(e) => updateSelectedItem('code', e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                شماره محصول را وارد کنید
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>توضیحات محصول</Form.Label>
                            <Form.Control as="textarea" rows={3} value={selectedItem.description} onChange={(e) => updateSelectedItem('description', e.target.value)} />
                        </Form.Group>

                        <div className="flex gap-3">
                            <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-1 !cursor-pointer" controlId="new-check">
                                <Form.Check checked={selectedItem.isNew} onChange={(e) => updateSelectedItem('isNew', !selectedItem.isNew)} id='new-check' />
                                <Form.Label className='font-bold mb-0'>محصول جدید</Form.Label>
                            </Form.Group>
                            <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-1 !cursor-pointer" controlId="popular-check">
                                <Form.Check checked={selectedItem.isFavorit} onChange={(e) => updateSelectedItem('isFavorit', !selectedItem.isFavorit)} id='popular-check' />
                                <Form.Label className='font-bold mb-0'>محصول محبوب</Form.Label>
                            </Form.Group>
                        </div>

                        <Form.Group className="mb-3 mt-3 d-flex align-items-center justify-content-start gap-3" controlId="exampleForm.ControlInput1">
                            <InputSwitch checked={selectedItem.isActive} onChange={(e) => updateSelectedItem('isActive', !selectedItem.isActive)} />
                            <Form.Label className='font-bold mb-0' style={{ width: 'fit-content', fontWeight: '700 !important' }}>وضعیت</Form.Label>
                        </Form.Group>
                        <div
                            className="upload-box mt-4 mb-0 flex-1"
                            {...getRootPropsEdit()}
                            style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}
                        >
                            <input {...getInputPropsEdit()} accept="image/*" />
                            <div>

                                <div>
                                    <img src={Upload} alt="آپلود تصویر" className="mx-auto" />
                                    <p className="text-xs mt-2 font-medium">امکان آپلود چهارتصویر برای محصول وجود دارد.</p>
                                    <h6 className="text-[10px]">بهترین ابعاد: 250 * 250</h6>
                                    <h6 className="text-[10px]">ماکزیمم حجم تصویر: ...</h6>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex gap-2 align-items-center" style={{ flexWrap: 'wrap' }}>
                            {selectedItem.images.length > 0 && (
                                <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                    {selectedItem.images.map((image, index) => (
                                        <div key={index} className="list-defult">
                                            <div className="d-flex align-items-center gap-2 mt-4" style={{ flexWrap: 'wrap' }}>
                                                <div className="upload-file-btn">
                                                    <img src={baseUrl + 'io/112x112/' + image.url} alt="Uploaded preview" className="image-preview" />
                                                    <div className="upload-file-btn-bottom">
                                                        <div className="d-flex align-items-center">
                                                            <RadioButton
                                                                inputId={image.id}
                                                                name="selected-images"
                                                                value={image.id}
                                                                onChange={(e) => changeDefaultImage(e.value)}
                                                                checked={selectedItem.images[index].isDefault}
                                                            />
                                                            <label htmlFor={image.id} className="ml-2">پیش فرض</label>
                                                        </div>
                                                        <div>
                                                            <img src={Trash} alt="حذف" onClick={() => removeImage(index, image)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}


                        </div>


                        {uploadStatus && <p className="upload-status mt-2">{uploadStatus}</p>}
                        <Form.Group className="mb-3 label-list mt-3" controlId="productLabels">
                            <Form.Label>لیبل محصول <span style={{ fontSize: '12px' }}>(برای ثبت لیبل دکمه enter را بزنید.)</span></Form.Label>
                            <div className="label-input-container">
                                {selectedItem.lables.length > 0 && selectedItem.lables.map((label, index) => (
                                    <>
                                        {label != "" &&
                                            < div key={index} className="label-item" >
                                                <span className="label-text">{label}</span>
                                                <button className="remove-btn" onClick={() => deleteLabel(label)}>
                                                    <img src={require('../../../assets/icons/trash-white.svg').default} alt="حذف" />
                                                </button>
                                            </div>
                                        }
                                    </>
                                ))}

                                {isAddingLabel ? (
                                    <input
                                        id="labels-input"
                                        type="text"
                                        className="add-label-input"
                                        value={addingLabelText}
                                        onChange={(e) => setAddingLabelText(e.target.value)}
                                        onKeyPress={addLabelKeyUp}
                                        autoFocus
                                        onBlur={cancleAddLabelNew} // بسته شدن ورودی در صورت خروج
                                        placeholder="لیبل جدید را وارد کنید"
                                    />
                                ) : (
                                    <button className="add-btn" onClick={openLabelAdding}>
                                        +
                                    </button>
                                )}
                            </div>
                        </Form.Group>



                        <div className='d-flex align-items-center gap-2'>
                            <button type="submit" disabled={loading} className="btn btn-primary flex-1">تایید و ثبت {loading && <Loader />}</button>
                            <button type="button" disabled={loading} className="btn btn-outline-primary flex-1" onClick={closeEditDialog}>انصراف</button>
                        </div>
                    </Form>

                </div >
            </Dialog >

            <Toast ref={deleteDialog} />
        </>
    );
}

export default Banner;
